export const ROOT_PATH = '/solicitud';
export const CALCULATOR_PATH = `${ROOT_PATH}/calculadora`;
export const SSO_TOKEN_PATH = `${ROOT_PATH}/auth`;
export const PERSONAL_DATA_PATH = `${ROOT_PATH}/datos-solicitante`;
export const IDENTITY_VALIDATION_PATH = `${ROOT_PATH}/aviso-privacidad`;
export const HOME_PATH = `${ROOT_PATH}/domicilio-actual`;
export const PRIVACY_BUREAU_VALIDATION_PATH = `${ROOT_PATH}/autorizacion-buro`;
export const WORK_PATH = `${ROOT_PATH}/informacion-laboral`;
export const REFERENCES_PATH = `${ROOT_PATH}/referencias`;
export const INSURANCES_PATH = `${ROOT_PATH}/seguros`;
export const FILES_UPLOAD_PATH = `${ROOT_PATH}/carga-archivos`;
export const SUMMARY_PATH = `${ROOT_PATH}/resumen`;
export const CREDIT_HISTORY_PATH = `${ROOT_PATH}/historial-credito`;
export const BUREAU_NOT_ELIGIBLE = `${ROOT_PATH}/no-elegible`;
export const TURBO_CASH_CALCULATOR = `${ROOT_PATH}/calculadora-turbo-cash`;
export const PROFILE_CALCULATOR = '/solicitud/calculadora-perfil';
export const TURBO_CASH = `${ROOT_PATH}/turbo-cash`;
export const FINISHED = `${ROOT_PATH}/fin`;
export const THANKS = `${ROOT_PATH}/gracias`;
export const THANKS_TURBOCASH = `${ROOT_PATH}/gracias-turbo-cash`;